<template>
  <tr>
    <td>{{ presentation.id }}</td>
    <td>{{ presentation.name }}</td>
    <td>{{ presentation.accessCode }}</td>
    <td>{{ presentation.uniqueAccessCode }}</td>
    <td><Formatter type="date" :value="presentation.createdAt" /></td>
    <td><Formatter type="date" :value="presentation.modifiedAt" /></td>
    <td><Formatter type="date" :value="presentation.updatedAt" /></td>
    <td class="text-center">
      <span
        v-if="isPresentationDeletedMoreThanAMonth"
        class="text-success pointer"
        @click="handleRecoverButtonClick()"
      >
        <i class="fa fa-spinner fa-spin" v-if="isPresentationRecovering"></i>
        <i class="fas fa-undo" v-else />
      </span>
    </td>
  </tr>
</template>

<script>
import moment from 'moment'

import configs from '../../config'

// UI
import Formatter from '../UI/Fomatter.vue'

export default {
  components: {
    Formatter,
  },
  data() {
    return {
      isPresentationRecovering: false,
    }
  },
  computed: {
    isPresentationDeletedMoreThanAMonth() {
      const now = moment()
      const deletedTimestamp = moment(this.presentation.updatedAt)

      return now.diff(deletedTimestamp, 'months') < 1
    },
  },
  props: {
    presentation: {
      type: Object,
      required: true,
    },
    handleRecoverPresentation: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async handleRecoverButtonClick() {
      const { id: presentationId, name } = this.presentation
      const areYouSure = confirm('Are you sure that you want to recover this presentation?')

      if (!areYouSure || this.isPresentationRecovering) return

      try {
        this.isPresentationRecovering = true
        await this.$http.post(configs.api.recoverPresentation, {
          presentationId,
        })
        this.handleRecoverPresentation(presentationId)
        this.$toasted.success(`Recover presentation ${name} successfully`)
      } catch {
        this.$toasted.error(`Recover presentation ${name} failed`)
      } finally {
        this.isPresentationRecovering = false
      }
    },
  },
}
</script>